/**
 * CXS tier-mapping modes for a telephony server. Both modes map the CX Score licence to the reporting tier
 * (CXS Agent for Call Centre Agent, CXS Manager for Call Centre Supervisor, either for None, neither for
 * Essentials, Professional or Enterprise), matching the backend rule in
 * {@code CReqRespUserBase.isUnsupportedReportingAccessForCXSLicense}, which treats both telsys types alike. They
 * differ only for a tier with no explicit mapping: MS Teams Business falls back to the unrestricted list while
 * BroadWorks allows no CXS licence.
 *
 * Telephony servers with neither mode use the legacy restricted/unrestricted behaviour.
 */
export const CXS_TELSYS_MODE = {
    TEAMS_BUSINESS: 'teamsBusiness',
    BROADWORKS: 'broadworks'
} as const

/** The CXS tier-mapping mode for a telephony server (see {@link CXS_TELSYS_MODE}). */
export type CxsTelsysMode = (typeof CXS_TELSYS_MODE)[keyof typeof CXS_TELSYS_MODE]
